import { useMutation, useQuery } from '@tanstack/react-query'

import {
  deleteOpenapiSpecsById,
  getOpenapiSpecsList,
  getOpenapiSpecsStatusById,
  postOpenapiSpecsCreate,
} from '~/generated/client'

export const useOpenAPISpecs = ({
  staleTime = 5000,
}: {
  staleTime?: number
}) => {
  const {
    data: openAPISpecs,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['openAPISpecs'],
    queryFn: getOpenapiSpecsList,
    staleTime: staleTime,
    refetchInterval: staleTime,
  })

  const {
    mutate: addOpenAPISpecMutation,
    isLoading: addOpenAPISpecLoading,
    error,
    data: addOpenAPISuccessData,
  } = useMutation({
    mutationFn: ({
      name,
      integrationYML,
      openAPISpec,
    }: {
      name: string
      integrationYML: string
      openAPISpec: string
    }) =>
      postOpenapiSpecsCreate({
        requestBody: {
          name,
          openApiSpec: openAPISpec,
          authConfig: integrationYML,
        },
      }),
    onSuccess: () => {
      refetch()
    },
  })

  const {
    mutate: deleteOpenAPISpecMutation,
    isLoading: deleteOpenAPISpecLoading,
  } = useMutation({
    mutationFn: (id: string) =>
      deleteOpenapiSpecsById({
        id,
      }),
    onSuccess: () => {
      refetch()
    },
  })

  return {
    openAPISpecs,
    isLoading,
    addOpenAPISpecMutation,
    addOpenAPISpecLoading,
    deleteOpenAPISpecMutation,
    deleteOpenAPISpecLoading,
    refetch,
    add: {
      error,
      addOpenAPISuccessData,
    },
  }
}

export const useLogs = (id: string) => {
  return useQuery(
    ['openAPISpecsLogs', id],
    async () => {
      return getOpenapiSpecsStatusById({ id: id }).then((res) => {
        return res
      })
    },
    {
      enabled: !!id,
      cacheTime: 0,
      refetchInterval: 5000,
    },
  )
}
